export const FILTER_TYPE_ANCILLARY = 'FILTER_TYPE_ANCILLARY';
